"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCreatedUpdatedFieldValue = void 0;
const dates_1 = require("./dates");
const objects_1 = require("./objects");
const typing_1 = require("./typing");
const primitives_1 = require("./primitives");
const id_1 = require("./id");
const string_1 = require("./string");
const isCreatedUpdatedFieldValue = (fieldValue) => {
    return (0, objects_1.isValidObjectValue)(fieldValue, {
        by: (0, typing_1.Union)(id_1.isNotEmptyIDValue, primitives_1.isNullValue),
        on: (0, typing_1.Union)(dates_1.isDateAsStringValue, string_1.isEmptyStringValue, primitives_1.isNullValue),
    });
};
exports.isCreatedUpdatedFieldValue = isCreatedUpdatedFieldValue;
